/**
 * @flow
 * @relayHash 66364691c5f9697812c3842a6a2fb46e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddressData = {|
  formattedAddress: string,
  types?: ?$ReadOnlyArray<?string>,
  placeId?: ?string,
  addressComplement?: ?string,
  addressComponents: $ReadOnlyArray<?AddressComponent>,
  geometry?: ?Geometry,
  partialMatch?: ?boolean,
|};
export type AddressComponent = {|
  types?: ?$ReadOnlyArray<?string>,
  shortName?: ?string,
  longName?: ?string,
|};
export type Geometry = {|
  locationType?: ?string,
  location?: ?Position,
  viewport?: ?Viewport,
  bounds?: ?Bound,
|};
export type Position = {|
  lat: number,
  lng: number,
|};
export type Viewport = {|
  northeast?: ?Position,
  southwest?: ?Position,
  east?: ?number,
  south?: ?number,
  west?: ?number,
  north?: ?number,
|};
export type Bound = {|
  east?: ?number,
  south?: ?number,
  west?: ?number,
  north?: ?number,
|};
export type editAddressTypeaheadQueryVariables = {|
  packageId: number,
  addressData: AddressData,
|};
export type editAddressTypeaheadQueryResponse = {|
  +privatePackageTrackerAddressValidation: ?{|
    +firstLine: ?string,
    +secondLine: ?string,
    +coordinates: ?{|
      +lat: number,
      +lng: number,
    |},
  |}
|};
export type editAddressTypeaheadQuery = {|
  variables: editAddressTypeaheadQueryVariables,
  response: editAddressTypeaheadQueryResponse,
|};
*/

/*
query editAddressTypeaheadQuery(
  $packageId: Int!
  $addressData: AddressData!
) {
  privatePackageTrackerAddressValidation(packageId: $packageId, addressData: $addressData) {
    firstLine
    secondLine
    coordinates {
      lat
      lng
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'packageId',
        type: 'Int!',
        defaultValue: null
      },
      {
        kind: 'LocalArgument',
        name: 'addressData',
        type: 'AddressData!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'privatePackageTrackerAddressValidation',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'addressData',
            variableName: 'addressData'
          },
          {
            kind: 'Variable',
            name: 'packageId',
            variableName: 'packageId'
          }
        ],
        concreteType: 'PrivateTrackerDestinationInfoNode',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            name: 'firstLine',
            args: null,
            storageKey: null
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'secondLine',
            args: null,
            storageKey: null
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'coordinates',
            storageKey: null,
            args: null,
            concreteType: 'PointNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'lat',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'lng',
                args: null,
                storageKey: null
              }
            ]
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'editAddressTypeaheadQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'editAddressTypeaheadQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'query',
      name: 'editAddressTypeaheadQuery',
      id: null,
      text:
        'query editAddressTypeaheadQuery(\n  $packageId: Int!\n  $addressData: AddressData!\n) {\n  privatePackageTrackerAddressValidation(packageId: $packageId, addressData: $addressData) {\n    firstLine\n    secondLine\n    coordinates {\n      lat\n      lng\n    }\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '713c9c62ca37c65bfc12432b88181de8';
module.exports = node;
